/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

// eslint-disable-next-line @typescript-eslint/naming-convention
export enum CONSTRAINT_ACCEPTANCE_STATE {
	UNASSIGNED = 'unassigned',
	ASSIGNED = 'assigned',
	ACCEPTED = 'accepted',
	COMPLETE = 'complete',
	INVALID = 'invalid',
}
